@if (pollsQuestions.VideoId) {
  <div class="game-question-video">
    <fgbcl-video-player [videoId]="pollsQuestions.VideoId"></fgbcl-video-player>
  </div>
} @else if (pollsQuestions.ImageUrl) {
  <div class="fgbcl-game-question-image">
    <img [src]="pollsQuestions.ImageUrl | contentImage: '6'" alt="{{ pollsQuestions.Title }}" />
  </div>
}
<div class="fgbcl-game-poll-result-question-block">{{ pollsQuestions?.Title }}</div>
<div
  class="games-polls-point-value-section"
  *ngIf="pollsQuestions?.PointsAwarded || pollsQuestions?.Prize?.PrizeValue"
  [@.disabled]="disableAnimation"
  [@pointsAnimation]
>
  <div class="games-polls-point-value">
    <span class="icon material-icons currency-icons pe-1" aria-label="Your Loyalty Points">{{ pointIcon }}</span
    >+{{ pollsQuestions.PointsAwarded || pollsQuestions?.Prize?.PrizeValue }}
    <span class="games-polls-pts-text">{{ 'fgbcl.currency.pts' | translate }}</span>
  </div>
</div>
<div class="fgbcl-game-answer-type-text-section">
  <ng-container *ngFor="let answer of pollsQuestions.Answers">
    <div class="fgbcl-game-poll-result-block">
      <div *ngIf="pollsQuestions.AnswerDisplayType == answerType.ImageAndText" class="mr-2">
        <img class="fgbcl-games-polls-answer-image" src="{{ answer.ImageUrl | contentImage: '7' }}" alt="{{ answer.answer }}" />
      </div>
      <div class="fgbcl-game-poll-result-progress-block">
        <div class="fgbcl-game-poll-result-answer-and-percentage-block">
          <div class="fgbcl-game-poll-result-answer-text">
            {{ answer.Title }}
          </div>
          <div class="fgbcl-game-poll-result-percentage-text">{{ answer.Percentage }}%</div>
        </div>
        <fgbcl-linear-progress-bar
          [backgroundClass]="answer.UserSelected ? 'bg-primary' : 'bg-disabled'"
          [progress]="answer.Percentage"
          [disableAnimation]="disableAnimation"
        ></fgbcl-linear-progress-bar>
      </div>
    </div>
  </ng-container>
</div>

<div class="fgbcl-games-polls-sponsor-section" *ngIf="pollsQuestions?.Sponsor?.SponsorId">
  <div class="fgbcl-games-polls-sponsor-text">{{ 'fgbcl.game.modal.sponsor.presented.by.text' | translate }}:</div>
  <img
    class="fgbcl-games-polls-sponsor-image"
    src="{{ pollsQuestions?.Sponsor?.SponsorImage | contentImage: '1' }}"
    alt="{{ pollsQuestions?.Sponsor?.SponsorText }}"
  />
</div>

<div class="d-flex justify-content-center align-items-center">
  <ng-content></ng-content>
</div>
